<template>
	<router-link class="button" :class="{ invert }" :to="{ name: to }">
		<slot />
	</router-link>
</template>

<script>
export default {
	name: 'NavButton',
	props: {
		to: String,
		invert: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';

.button {
	&:not(.invert) {
		@include button($blue-48, $white, $blue-48, $blue-98);
	}
	&.invert {
		@include button;
	}
}
</style>
